import { KTSVG } from '_metronic/helpers'
import { computePileHoleSummary, PileHoleTableRow } from '../pileHoleMapper'

interface Props {
  data: PileHoleTableRow[]
}

const PlanSummaryCards: React.FC<Props> = ({ data }) => {
  const { total, inProgress, completed, other, progressPercent } = computePileHoleSummary(data)

  const items = [
    {
      label: 'ทั้งหมด',
      value: total,
      icon: '/media/icons/duotune/general/gen025.svg',
      iconClass: 'svg-icon-primary',
    },
    {
      label: 'กำลังดำเนินการ',
      value: inProgress,
      icon: '/media/icons/duotune/general/gen019.svg',
      iconClass: 'svg-icon-info',
    },
    {
      label: 'เสร็จสิ้น',
      value: completed,
      icon: '/media/icons/duotune/general/gen043.svg',
      iconClass: 'svg-icon-success',
    },
    {
      label: 'อื่นๆ',
      value: other,
      icon: '/media/icons/duotune/general/gen013.svg',
      iconClass: 'svg-icon-warning',
    },
  ]

  return (
    <div className='px-9 pt-6 pb-2'>
      <div className='d-flex flex-wrap gap-4 mb-6'>
        {items.map(item => (
          <div
            key={item.label}
            className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 flex-grow-1'>
            <div className='d-flex align-items-center mb-2'>
              <KTSVG path={item.icon} className={`svg-icon-2 ${item.iconClass} me-2`} />
              <div className='fs-2 fw-bolder text-gray-800'>{item.value}</div>
            </div>
            <div className='fw-bold fs-7 text-gray-500'>{item.label}</div>
          </div>
        ))}
      </div>

      <div>
        <div className='d-flex justify-content-between mb-2'>
          <span className='fw-bold fs-7 text-gray-600'>ความคืบหน้าการตอกทั้งโครงการ</span>
          <span className='fw-bolder fs-7 text-gray-800'>{progressPercent.toFixed(1)}%</span>
        </div>
        <div className='h-8px bg-light rounded'>
          <div
            className='bg-success rounded h-8px'
            role='progressbar'
            style={{ width: `${Math.min(progressPercent, 100)}%` }}
          />
        </div>
      </div>
    </div>
  )
}

export default PlanSummaryCards
